import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useUserGate } from '@/auth/UserGate/useUserGate';
import { PageSpinner } from '@/components/Spinner/PageSpinner';

export const UserGate: React.FC = () => {
  const { isFetching, redirectPath } = useUserGate();

  if (isFetching) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <PageSpinner />
      </div>
    );
  }

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};
